import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { COLORS } from '@/global-styles';
import i18n from '@/i18n';

const MySwal = withReactContent(Swal);

export function showConfirm(
  text = i18n.t('notify.confirm'),
  fakeLoadingMs?: number,
  isCloseWhenApiDone?: boolean
): any {
  let closeRef: (() => void) | null = null;
  const _promise = new Promise<boolean>((resolve) => {
    MySwal.fire({
      title: "Warning",
      text,
      html: text.replace(/\n/g, "<br/>"),
      width: 540,
      icon: "warning",
      confirmButtonText: i18n.t("common.confirm") as string,
      confirmButtonColor: COLORS.violet_2,
      showCancelButton: true,
      cancelButtonText: i18n.t("common.cancel") as string,
      focusConfirm: false,
      focusCancel: false,
      scrollbarPadding: false,
      showLoaderOnConfirm: !!fakeLoadingMs || isCloseWhenApiDone,
      preConfirm: () => false,
      didOpen: () => {
        const confirmBtn = MySwal.getConfirmButton();
        const cancelBtn = MySwal.getCancelButton();
        const htmlContainer = MySwal.getHtmlContainer();
        if (htmlContainer) {
          htmlContainer.style.fontSize = '1rem';
        }
        closeRef = () => MySwal.close();
        cancelBtn?.addEventListener("click", () => {
          resolve(false);
          MySwal.close();
        });
        confirmBtn?.addEventListener("click", () => {
          resolve(true);
          if (isCloseWhenApiDone) {
            MySwal.showLoading();
            return;
          }
          if (!fakeLoadingMs) {
            MySwal.close();
            return;
          }
          MySwal.showLoading();
          setTimeout(() => {
            MySwal.close();
          }, fakeLoadingMs);
        });
      }
    });
  });
  if (!isCloseWhenApiDone) return _promise;
  return { promise: _promise, close: () => { if (closeRef) closeRef(); } };
}

export const showError = (errorMessage = i18n.t('common.modal.error')) => {
  return MySwal.fire({
    title: 'Error',
    text: errorMessage,
    html: errorMessage.replace(/\n/g, '<br/>'),
    width: 540,
    icon: 'error',
    confirmButtonText: 'Ok',
    confirmButtonColor: COLORS.violet_2,
    // reverseButtons: true,
    focusConfirm: false,
    focusCancel: false,
    scrollbarPadding: false,
    didOpen: () => {
      const htmlContainer = MySwal.getHtmlContainer();
      if (htmlContainer) {
        htmlContainer.style.fontSize = '1rem';
      }
    },
  });
};

export const showSuccess = (message = i18n.t('common.modal.success')) => {
  return MySwal.fire({
    title: 'Success',
    html: message.replace(/\n/g, '<br/>'),
    width: 540,
    icon: 'success',
    confirmButtonText: 'Ok',
    confirmButtonColor: COLORS.violet_2,
    // reverseButtons: true,
    focusConfirm: false,
    focusCancel: false,
    scrollbarPadding: false,
    didOpen: () => {
      const htmlContainer = MySwal.getHtmlContainer();
      if (htmlContainer) {
        htmlContainer.style.fontSize = '1rem';
      }
    },
  });
};

export const showModal = (text = i18n.t('notify.confirm')) => {
  return MySwal.fire({
    title: 'Warning',
    html: text.replace(/\n/g, '<br/>'),
    width: 540,
    icon: 'warning',
    confirmButtonText: 'Ok',
    confirmButtonColor: COLORS.violet_2,
    showCancelButton: true,
    cancelButtonText: 'Cancel',
    // reverseButtons: true,
    focusConfirm: false,
    focusCancel: false,
    scrollbarPadding: false,
    didOpen: () => {
      const htmlContainer = MySwal.getHtmlContainer();
      if (htmlContainer) {
        htmlContainer.style.fontSize = '1rem';
      }
    },
  }).then((result) => {
    return result.isConfirmed;
  });
};

export const showDetail = (text = i18n.t('notify.confirm')) => {
  return MySwal.fire({
    title: 'Warning',
    text: text,
    html: text.replace(/\n/g, '<br/>'),
    width: 540,
    icon: 'warning',
    confirmButtonText: i18n.t('limit.view_detail') as string,
    confirmButtonColor: COLORS.violet_2,
    showCancelButton: true,
    cancelButtonText: 'Cancel',
    // reverseButtons: true,
    focusConfirm: false,
    focusCancel: false,
    scrollbarPadding: false,
    didOpen: () => {
      const htmlContainer = MySwal.getHtmlContainer();
      if (htmlContainer) {
        htmlContainer.style.fontSize = '1rem';
      }
    },
  }).then((result) => {
    return result.isConfirmed;
  });
};

export const showDetailSuccess = (text = i18n.t('common.modal.success')) => {
  return MySwal.fire({
    title: 'Success',
    text: text,
    html: text.replace(/\n/g, '<br/>'),
    width: 540,
    icon: 'success',
    confirmButtonText: i18n.t('limit.view_detail') as string,
    confirmButtonColor: COLORS.violet_2,
    showCancelButton: true,
    cancelButtonText: 'Cancel',
    // reverseButtons: true,
    focusConfirm: false,
    focusCancel: false,
    scrollbarPadding: false,
    didOpen: () => {
      const htmlContainer = MySwal.getHtmlContainer();
      if (htmlContainer) {
        htmlContainer.style.fontSize = '1rem';
      }
    },
  }).then((result) => {
    return result.isConfirmed;
  });
};

export const showDetailUrl = (text = i18n.t('common.modal.success')) => {
  return MySwal.fire({
    text: text,
    icon: 'warning',
    html: text.replace(/\n/g, '<br/>'),
    width: 540,
    confirmButtonColor: COLORS.violet_2,
    // reverseButtons: true,
    focusConfirm: false,
    focusCancel: false,
    scrollbarPadding: false,
    didOpen: () => {
      const htmlContainer = MySwal.getHtmlContainer();
      if (htmlContainer) {
        htmlContainer.style.fontSize = '1rem';
      }
    },
  }).then((result) => {
    return result.isConfirmed;
  });
};
